import { AppState } from 'store/rootReducer';

const selectModalState = (state: AppState) => state.modal;

/**
 * Given a modal indentifier generates a selector that returns
 * true if the modal is visible.
 * @param modalName A valid modal identifier.
 */
export const makeSelectIsModalVisible =
  (modalName: string) => (state: AppState) =>
    selectModalState(state)[modalName] || false;
